import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import {useEdits} from "../../../contexts/edits";
import {useSetting} from "../../../contexts/setting";
import {useImages} from "../../../contexts/images";
import BgTransformer from "../../../layout/BgTransformer";
import adsAssets from "../../../data/ads-assets.json";

const DailyDevAds = ({id, zoom}) => {
  const {channel, product, type, bgOption, locked} = useSetting();
  const {customBgs} = useImages();
  const isLocked = locked.some((x) => x === id);
  // Per-template custom bg wins over the shared one (only when locked);
  // unlocking falls back to .main automatically.
  const customBgUrl = (isLocked ? customBgs[id] : undefined) || customBgs.main || null;
  const {titles, subtitles} = useEdits();
  const title = titles[id] || titles.main;
  const subtitle = subtitles[id] || subtitles.main;

  // Manifest miss is expected during channel-switch transitions (URL params
  // updated before useSetting commits) and for combos that haven't been baked
  // yet. Soft-fall-through: skip the background rather than crashing the page.
  const bgIdx = bgOption || 1;
  const assetKey = `${channel.value}/${product.value}/${type.value}/${bgIdx}/${id}`;
  const bgUrl = adsAssets[assetKey]?.url;

  return (
    <div id={id} className={`template ${type.value} tpl-card`} style={{"--zoom-level": zoom}}>
      <div className="tpl-card__inner">
        {customBgUrl || bgUrl ? <BgTransformer src={customBgUrl || bgUrl} id={id} /> : null}
        <div className="tpl-bubble">
          <h2 className="subtitle">
            <Textarea id={id} text={subtitle} />
          </h2>
          {/* Tail path lifted verbatim from Figma node 1733:193 (Vector 1). */}
          <svg
            className="tpl-bubble__tail"
            viewBox="0 0 40 46"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M0 45.7415C0 45.7415 10.3347 17.9904 10.3347 0L39.9999 21.6267C25.263 39.043 0 45.7415 0 45.7415Z"
              fill="currentColor"
            />
          </svg>
        </div>
        <h1 className="title">
          <Textarea id={id} text={title} />
        </h1>
      </div>
    </div>
  );
};

export default DailyDevAds;
